import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MbscDatepickerOptions, MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PDxListItem } from 'src/app/core/PDxListItem.model';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { VERelationshipInformation } from '../models/ve-relationship-information.model';

@Component({
  selector: 'app-assign-entity',
  templateUrl: './assign-entity.component.html',
  styles: [
  ]
})
export class AssignEntityComponent implements OnInit {
  @Input() vendorId: string;
  @Input() entityId: string;
  @ViewChild(NgForm) relationshipForm: NgForm;

  filterCount: number = 0;
  accountId: string = null;
  accounts: PDxListItem<string>[] = [];
  parentId: string = null;
  parents: PDxListItem<string>[] = [];
  relationship: VERelationshipInformation = null;
  submitAttempt: boolean = false;
  dateOptions: MbscDatepickerOptions = {
    controls: ['calendar'],
    theme: 'ios',
    themeVariant: 'light',
    returnFormat: 'locale',
    dateFormat: 'M/D/YYYY',
  };
  accountOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            this.validateCurrentAccount();
          }
        }, () => { });
      } else {
        this.validateCurrentAccount();
      }
      return false;
    },
    onChange: (ev: any) => {
      this.relationship.hierarchy = this.accounts.filter((x) => x.value == ev.value);
      this.relationship.masterHierarchy = [];
      this.parentId = null;
      this.parents = [];
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.relationship.hierarchy = [];
        this.relationship.masterHierarchy = [];
        this.accountId = null;
        this.parentId = null;
        this.parents = [];
      }
    }]
  };

  parentOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.parents = [];
      if (!this.accountId) {
        return false;
      }
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: this.accountId, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.parents = data;
            this.validateCurrentParent()
          }
        }, () => { });
      } else {
        this.validateCurrentParent()
      }
      return false;
    },
    onChange: (ev: any) => {
      this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/Hierarchy', { entityId: this.parentId }, false).then((data) => {
        this.relationship.hierarchy = data;
      }, () => { });
      this.ajax.MakeCall<PDxListItem<string>[]>('/Vendor/MasterHierarchy', { entityId: this.parentId, vendorId: this.vendorId }, false).then((data) => {
        this.relationship.masterHierarchy = data;
      }, () => { });
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.relationship.hierarchy = this.accounts.filter((x) => x.value == this.accountId);
        this.relationship.masterHierarchy = this.accounts.filter((x) => x.value == this.accountId);
        this.parentId = null;
      }
    }]
  };

  masterFileOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
  };

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.loadForm();
  }

  private loadForm(): void {
    this.filterCount = 0;
    this.accountId = null;
    this.accounts = [];
    this.parentId = null;
    this.parents = [];
    this.relationship = null;
    this.submitAttempt = false;

    this.ajax.MakeCall<VERelationshipInformation>('/Vendor/Relationship', { vendorId: this.vendorId, entityId: this.entityId }).then((data) => {
      this.relationship = data;
      if (this.relationshipForm) {
        this.relationshipForm.form.markAsPristine();
      }
    }, () => { });
  }

  validateCurrentAccount(): void {
    if (this.relationship.hierarchy.length > 0) {
      if (this.accounts.filter((x) => x.value == this.relationship.hierarchy[0].value).length == 0) {
        this.accounts.splice(0, 0, this.relationship.hierarchy[0]);
      }
    }
  }

  validateCurrentParent(): void {
    if (this.relationship.hierarchy.length > 1) {
      if (this.parents.filter((x) => x.value == this.relationship.hierarchy[this.relationship.hierarchy.length - 1].value).length == 0) {
        this.parents.splice(0, 0, this.relationship.hierarchy[this.relationship.hierarchy.length - 1]);
      }
    }
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  private accountIds: string[] = [];
  save(andClose: boolean): void {
    this.submitAttempt = true;
    if (this.relationshipForm.invalid) {
      return;
    }

    if (!this.relationship.entityId) {
      this.relationship.entityId = this.parentId || this.accountId;
    }
    this.ajax.MakeCall<string>('/Vendor/SaveRelationship', this.relationship).then((aId) => {
      if (this.accountIds.filter(a => a == aId).length == 0) {
        this.accountIds.push(aId);
      }
      if (andClose) {
        this.modal.close(this.accountIds);
      } else {
        this.loadForm();
      }
    }, () => { });
  }

  markDirty(): void {
    this.relationshipForm.form.markAsDirty();
  }
}
